export default __webpack_public_path__ + "static/media/check_validate-white.d59a7da9.svg";